import { NumberToBootstrapSizeBaseValueConverter } from 'General/Resources/ValueConverters/NumberToBootstrapSizeBase';

export class NumberToBootstrapSizeValueConverter extends NumberToBootstrapSizeBaseValueConverter {

}